// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"223":"commons","293":"component---src-pages-index-js","342":"ea88be26","696":"component---src-pages-de-js"}[chunkId] || chunkId) + "-" + {"223":"b2f6334d02b623d83ab6","293":"c0c070ca6120f01de4c0","342":"f4e8dde97a8266a411ef","454":"bd0225b76aa2a1dd8b29","696":"02724a677551fe106542"}[chunkId] + ".js";
};